import type { SkillsProgress_SortField as SortField } from '__generated__/graphql-types';
import {
  SkillsProgress_SkillLevel as SkillLevel,
  SkillsProgress_SortDirection as SortDirection,
} from '__generated__/graphql-types';

import { getLevelsetStatus } from 'bundles/enterprise-legacy-learner-home/components/myLearning/skillsDashboard/withSkillsData';
import type { SkillsProgress_SkillProgressFragment as SkillsProgressV2 } from 'bundles/page-config-common/queries/__generated__/SkillsProgress_SkillProgress';

import _t from 'i18n!nls/consumer-home';

export const getProgressMadeValuesAndLabels = () => {
  return [
    { value: Number.MAX_SAFE_INTEGER, label: _t('At any time') },
    { value: 30, label: _t('in the last 30 days') },
    { value: 60, label: _t('in the last 60 days') },
    { value: 90, label: _t('in the last 90 days') },
  ];
};

export const getSkillLevelValuesAndLabels = () => {
  return [
    { value: '', label: _t('Any skill level') },
    { value: SkillLevel.Conversant, label: _t('Conversant') },
    { value: SkillLevel.Beginner, label: _t('Beginner') },
    { value: SkillLevel.Intermediate, label: _t('Intermediate') },
    { value: SkillLevel.Advanced, label: _t('Advanced') },
  ];
};

export const mapSkillToOldSkillsProgressType = (skillProgress: SkillsProgressV2) => {
  return {
    skillId: skillProgress.skill.id,
    skillName: skillProgress.skill.skillName,
    // Domains are no longer used in V2 of the dashboard
    domains: [],
    // Latest and Trending Skills only returns skills that a learner can receive a score in
    isEligibleForScoring: true,
    score: skillProgress.skillScore.score,
    // The old skills dashboard used the scoreAtTime to filter on the FE, we've moved the filtering to the BE
    // and this field is no longer needed
    scoredAtTime: 0,
    levelsetStatus: getLevelsetStatus(skillProgress.levelSetStatus),
  };
};

export const getSkillProgressSortOption = (sortField: SortField) => {
  if (sortField === 'SKILL_NAME') {
    return { direction: SortDirection.Asc, field: sortField };
  } else {
    return { direction: SortDirection.Desc, field: sortField };
  }
};
